import { render, staticRenderFns } from "./order_car.vue?vue&type=template&id=f087d424&scoped=true"
import script from "./order_car.vue?vue&type=script&lang=js"
export * from "./order_car.vue?vue&type=script&lang=js"
import style0 from "./order_car.vue?vue&type=style&index=0&id=f087d424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f087d424",
  null
  
)

export default component.exports